import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useClassEnrollmentsQuery } from "../api/queries";
import { ClassEnrollmentsFilter } from "../ui/ClassEnrollmentsFilter";
import { ClassEnrollmentsTable } from "../ui/ClassEnrollmentsTable";

type Search = {
  limit: number;
  offset: number;
  status?: string;
  phone?: string;
};

export function ClassEnrollmentsPage() {
  const nav = useNavigate({ from: "/app/class-enrollments" });
  const search = useSearch({ from: "/app/class-enrollments" }) as Search;
  const { data, isLoading } = useClassEnrollmentsQuery({
    limit: search.limit,
    offset: search.offset,
    status: search.status,
    phone: search.phone,
  });

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ໃບສະໝັກຮຽນ" },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-6">
          <h1 className="font-bold text-2xl">ໃບສະໝັກຮຽນ</h1>
          <p className="mt-1 text-muted-foreground text-sm">
            ລາຍການທີ່ຍັງລໍຖ້າຢືນຢັນຢູ່ດ້ານເທິງ — ຢືນຢັນທີ່ເຄົາເຕີແລ້ວຈຶ່ງປ່ຽນເປັນນັກຮຽນ
          </p>
        </div>
        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <ClassEnrollmentsFilter />
          <ClassEnrollmentsTable
            data={data?.data ?? []}
            isLoading={isLoading}
            offset={search.offset}
            limit={search.limit}
            totalCount={data?.meta.total ?? 0}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            onView={(id) => nav({ to: "/app/class-enrollments/$id", params: { id } })}
          />
        </div>
      </Main>
    </>
  );
}
